<template>
  <div class="t-inline-flex">
    <div
      @click="onCardViewClick"
      class="view t-border-2 t-border-gray-500 t-inline-block t-rounded t-mr-2 t-cursor-pointer"
      :class="{ 't-border-dodger-blue': viewOption === 'card' }"
    >
      <div class="card-view__block card-view__block--top t-bg-black" :class="{ 't-bg-dodger-blue': viewOption === 'card' }"/>
      <div class="card-view__block t-bg-black" :class="{ 't-bg-dodger-blue': viewOption === 'card' }"/>
    </div>

    <div
      @click="onListViewClick"
      class="view--list t-border-2 t-border-gray-600 t-inline-block t-rounded t-cursor-pointer"
      :class="{ 't-border-dodger-blue': viewOption === 'list' }"
    >
      <div class="t-flex t-h-full t-justify-center t-items-center">
        <i class="fas fa-bars" style="width: 0.875rem;" :style="{ color: viewOption === 'list' ? '#18a9e1' : '#4B5563' }"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ViewModeSelector',
  emits: ['cardViewClicked', 'listViewClicked'],
  data() {
    return {
      viewOption: 'card'
    }
  },
  methods: {
    onCardViewClick() {
      this.viewOption = 'card';
      this.$emit('cardViewClicked');
    },
    onListViewClick() {
      this.viewOption = 'list';
      this.$emit('listViewClicked');
    }
  }
}
</script>

<style scoped>
.card-view__block {
    height: 0.35rem;
    width: 0.875rem;
}

.card-view__block--top {
    margin-bottom: 0.2rem;
}

.view {
    height: 1.55rem;
    padding: 0.2rem 0.2rem;
}

.view--list {
    height: 1.55rem;
    padding: 0 0.2rem;
}

</style>